import { render, staticRenderFns } from "./FaceRadio.vue?vue&type=template&id=2cffd07d&scoped=true&lang=pug&"
import script from "./FaceRadio.vue?vue&type=script&lang=ts&"
export * from "./FaceRadio.vue?vue&type=script&lang=ts&"
import style0 from "./FaceRadio.vue?vue&type=style&index=0&id=2cffd07d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cffd07d",
  null
  
)

export default component.exports